import apiWrapper from '../../../../../common/api/api-wrapper';
import { IAPIErrorContent } from '../../../../../common/api/type-def';

import {
	IDataBaseOptionsResponse,
	IGetTaxonomyHeatMapData,
	IGetTaxonomyHeatMapParams,
	IHeatMapViewResponse,
	IInstitutionTypeListResponse,
	IJurisdictionListResponse,
	ISearchGetCountsResponse,
	ITaxonomyListGridResponse,
} from './type-def.js';

const { REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL } = process.env;

export const getJurisdictionList = async () => {
	const resp = await apiWrapper.get<
		IJurisdictionListResponse[],
		IAPIErrorContent
	>(`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/relation-mapping/jurisdiction`);
	return resp;
};

export const getInstitutionTypeList = async () => {
	const resp = await apiWrapper.get<
		IInstitutionTypeListResponse[],
		IAPIErrorContent
	>(`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/relation-mapping/institutions`);
	return resp;
};

export const getSearchRiskReferenceValues = async (data: any) => {
	const resp = await apiWrapper.post<
		ISearchGetCountsResponse,
		IAPIErrorContent
	>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/elastic-search/taxonomy/entity/count`,
		data,
	);
	return resp;
};

export const getTaxonomyRefTableData = async (data: any, params: any) => {
	const sortKey = params?.sortKey ? params?.sortKey : '';
	const sortDirection = params?.sortDirection ? params?.sortDirection : '';
	const sort = sortKey !== '' ? `${sortKey},${sortDirection}` : '';
	const url = `${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/elastic-search/search?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sort=${sort}`;
	const resp = await apiWrapper.post<
		ITaxonomyListGridResponse,
		IAPIErrorContent
	>(url, data);
	return resp;
};

export const getTaxonomyHeatMapData = async (
	data: IGetTaxonomyHeatMapData,
	params: IGetTaxonomyHeatMapParams,
) => {
	const defaultPageSize = 24;
	const resp = await apiWrapper.post<IHeatMapViewResponse, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/elastic-search/heat-score/search?pageNumber=${params?.pageNumber}&pageSize=${defaultPageSize}`,
		data,
	);
	return resp;
};

export const getDataBaseOptionsList = async () => {
	const resp = await apiWrapper.get<
		IDataBaseOptionsResponse[],
		IAPIErrorContent
	>(`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/ui/config/taxonomy`);
	return resp;
};
